// @ts-nocheck
import translate from "@insite/client-framework/Translate";
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Store Custom Code
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { FC } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
/* Store Custom Code - End */

interface OwnProps {
    path: string;
}

type Props = OwnProps;

const addToCartButton: ButtonPresentationProps = {};

const StoreVariantsButton: FC<Props> = ({ path }) => {
    const history = useHistory();

    const productDetailPath = () => {
        history.push(path);
    };

    return (
        <Button {...addToCartButton} onClick={productDetailPath}>
            {translate("Select options")}
        </Button>
    );
};

export default StoreVariantsButton;
